import React from 'react';
import { MSocialGroupProps, MSocialGroupIconInteractive } from './MSocialGroup.types';
import { Wrapper, IconsContainer } from './MSocialGroup.styles';
import { ASubheader } from '../../atoms/ASubheader/index';
import { MIconInteractive } from '../MIconInteractive/index';

const COMPONENT_NAME = 'm-web-ui-kit-MSocialGroup';
const TEST_ID = 'web-ui-kit-MSocialGroup';

export const MSocialGroup: React.FC<MSocialGroupProps> = ({
  orientation,
  aSubheader,
  mIconInteractive,
  onNavigate,
  onIconMouseEnter,
  onIconMouseLeave,
}) => {
  return (
    <Wrapper orientation={orientation} data-component-name={COMPONENT_NAME} data-testid={TEST_ID}>
      {aSubheader && <ASubheader {...aSubheader} />}
      {mIconInteractive && mIconInteractive.length > 0 && (
        <IconsContainer orientation={orientation}>
          {mIconInteractive.map((iconItem: MSocialGroupIconInteractive, index) =>
            (() => {
              const opensInNewTab = iconItem.openInANewTab === true || iconItem.openInANewTab === 'true';
              return (
                <MIconInteractive
                  key={`${iconItem.aIcon?.icon ?? 'icon'}-${index}`}
                  aIcon={iconItem.aIcon}
                  ctaLink={iconItem.ctaLink}
                  openInANewTab={iconItem.openInANewTab}
                  onClick={event => {
                    event.preventDefault();
                    onNavigate(iconItem.ctaLink, opensInNewTab);
                  }}
                  onMouseEnter={() => onIconMouseEnter?.(iconItem.ctaLink, opensInNewTab)}
                  onMouseLeave={() => onIconMouseLeave?.(iconItem.ctaLink, opensInNewTab)}
                  ariaLabel={iconItem.aIcon?.icon || ''}
                  trackingProperties={iconItem.trackingProperties}
                  custom_click_track_value={iconItem.custom_click_track_value}
                />
              );
            })()
          )}
        </IconsContainer>
      )}
    </Wrapper>
  );
};
